import { CaretRightIcon } from "@phosphor-icons/react/dist/csr/CaretRight";
import { Item, ItemActions, ItemContent } from "@volca/ui/components/ui/item";
import { Text } from "@volca/ui/components/ui/text";
import { cn } from "@volca/ui/lib/utils";
import { dayjs } from "@/core/utils/date";
import { formatMoney } from "@/core/utils/money";
import type { IcmLineItem } from "@/icm/types";

export const StatementLineItemCard = ({
  lineItem,
  onClick,
}: {
  lineItem: IcmLineItem;
  onClick: () => void;
}) => (
  <Item
    variant="outline"
    render={<button type="button" />}
    onClick={onClick}
    className={cn("flex-nowrap bg-surface-raised text-left", {
      "border-warning-line bg-warning-subtle": lineItem.warnings.length > 0,
    })}
  >
    <ItemContent className="min-w-0 gap-0">
      <Text
        variant="title"
        className="truncate"
        title={lineItem.customer_name ?? lineItem.payout_rule_name}
      >
        {lineItem.customer_name ?? lineItem.payout_rule_name}
      </Text>
      <Text variant="caption" tone="muted">
        {lineItem.job_completed_on
          ? dayjs(lineItem.job_completed_on).format("MMM D, YYYY")
          : "No completion date"}
      </Text>
      {lineItem.warnings.length > 0 && (
        <Text className="mt-0.5 text-xs text-warning">
          {lineItem.warnings[0]}
        </Text>
      )}
    </ItemContent>
    <ItemActions className="shrink-0 gap-1">
      <Text variant="title">{formatMoney(lineItem.payout_amount) ?? "–"}</Text>
      <CaretRightIcon className="h-4 w-4 text-subtle" />
    </ItemActions>
  </Item>
);
